import { render, staticRenderFns } from "./EditInstr.vue?vue&type=template&id=45dd413f&scoped=true&"
import script from "./EditInstr.vue?vue&type=script&lang=js&"
export * from "./EditInstr.vue?vue&type=script&lang=js&"
import style0 from "./EditInstr.vue?vue&type=style&index=0&id=45dd413f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dd413f",
  null
  
)

export default component.exports